import axios from 'axios';

export const getSalesReport = async (payload: any) => {
    let url: any = process.env.REACT_APP_SABRE_URL + `/tickets/salesReports`;
    const requestOptions: any = {
        headers: {
            "Content-type": "application/json",
        },
    }
    const result: any = await axios.post(url, payload, requestOptions);

    return result?.data;

}